import e from "react";
import { getIconColor as l } from "./iconfont.es5470.js";
import u from "./iconfont.es5471.js";
const i = {
  display: "block"
}, v = ({ size: t = 16, useVw: o, useRem: r, color: a, withColor: n, removeClassName: m, disableSSR: d, style: c, ...f }) => {
  const p = c ? { ...i, ...c } : i;
  return /* @__PURE__ */ e.createElement(u, { disableSSR: d }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "icon-20px-yuyanv31", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 20 20", width: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (r ? "rem" : "px"), height: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (r ? "rem" : "px"), className: m ? "" : "iconpark-icon", style: p, fill: "none", ...f }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#125866__a)"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: n ? l(a, 0, "currentColor") : "currentColor",
        datafollowfill: n ? l(a, 0, "currentColor") : "currentColor",
        d: "M5.499 10.8a12.004 12.004 0 0 0 2.546 6.65 7.706 7.706 0 0 1-5.704-6.65H5.5Zm1.604 0A10.404 10.404 0 0 0 10 17.259a10.404 10.404 0 0 0 2.898-6.459H7.103Zm5.795-1.6H7.103A10.404 10.404 0 0 1 10 2.741 10.404 10.404 0 0 1 12.898 9.2Zm1.604 1.6a12.004 12.004 0 0 1-2.546 6.65 7.706 7.706 0 0 0 5.703-6.65h-3.157Zm3.157-1.6h-3.157a12.004 12.004 0 0 0-2.546-6.65 7.706 7.706 0 0 1 5.703 6.65ZM5.5 9.2H2.34a7.706 7.706 0 0 1 5.704-6.65A12.004 12.004 0 0 0 5.499 9.2Zm13.8.8A9.3 9.3 0 1 1 .7 10a9.3 9.3 0 0 1 18.6 0Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "125866__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fill: n ? l(a, 1, "#fff") : "#fff",
        d: "M0 0h20v20H0z"
      }
    )
  )));
}, s = v;
export {
  s as default
};
